import { useEffect, useReducer } from 'react';
import { flushSync } from 'react-dom';
import { app, type Channel } from './app.ts';

/** Re-render when any of the channels fire (coalesced to one update per animation frame). */
export function useApp<T>(channels: Channel | Channel[], selector: () => T, opts: { sync?: boolean } = {}): T {
  const [, force] = useReducer((x: number) => x + 1, 0);
  const list = Array.isArray(channels) ? channels : [channels];
  useEffect(() => {
    let raf = 0;
    const fire = () => {
      if (opts.sync) {
        // render immediately (e.g. mounting the text editor before the next keystroke)
        queueMicrotask(() => flushSync(force));
        return;
      }
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        force();
      });
    };
    const offs = list.map((c) => app.on(c, fire));
    return () => {
      offs.forEach((f) => f());
      if (raf) cancelAnimationFrame(raf);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.join(',')]);
  return selector();
}
